const KEY = 'sampleRequestColors';

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch {
    return [];
  }
};

const write = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event('sampleRequestColors:change'));
};

export const getSampleColors = read;

export const isInSampleRequest = (colorId) => read().some((s) => s.color_id === colorId);

// Adds a gallery entry to the shared /request-samples cart; returns the new count.
export const addSampleColor = (entry) => {
  const items = read();
  if (!items.some((s) => s.color_id === entry.id)) {
    items.push({
      color_id: entry.id,
      color_name: entry.name,
      color_code: entry.code,
      hex_color: entry.hex_color,
      image_url: entry.image_url,
      brand_name: entry.brand_name,
      collection_name: entry.collection_name,
      material_name: entry.material_name,
    });
    write(items);
  }
  return items.length;
};

export const removeSampleColor = (colorId) => {
  const items = read().filter((s) => s.color_id !== colorId);
  write(items);
  return items.length;
};
